<template>
  <div class="youth-lock" role="alertdialog" aria-modal="true" aria-labelledby="youth-lock-title">
    <div class="lock-card">
      <div class="lock-mark" aria-hidden="true">
        <svg viewBox="0 0 64 64" class="lock-icon">
          <path d="M18 28v-7c0-7.7 6.3-14 14-14s14 6.3 14 14v7" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" />
          <rect x="12" y="28" width="40" height="29" rx="8" fill="currentColor" opacity="0.16" />
          <rect x="12" y="28" width="40" height="29" rx="8" fill="none" stroke="currentColor" stroke-width="4" />
          <path d="M32 40v7" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" />
        </svg>
      </div>
      <p class="eyebrow">青少年保护模式</p>
      <h2 id="youth-lock-title">今日守护时间已达上限</h2>
      <p class="lock-desc">为了保护青少年休息与用眼健康，今日网站访问时间已满 2 小时。请关闭网站，明天再继续访问。</p>
      <div class="lock-panel">
        <div>
          <span>今日已使用</span>
          <strong>{{ usedText }}</strong>
        </div>
        <div>
          <span>恢复时间</span>
          <strong>明天自动重新计时</strong>
        </div>
      </div>
      <p class="lock-tip">当前页面已被保护模式锁定，站内不提供关闭入口。</p>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { formatYouthProtectionDuration } from '@/utils/youthProtection';

export default {
  name: 'YouthProtectionLock',
  props: {
    usedMs: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const usedText = computed(() => formatYouthProtectionDuration(props.usedMs));

    return {
      usedText
    };
  }
};
</script>

<style scoped>
.youth-lock {
  position: fixed;
  inset: 0;
  z-index: 12000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(17, 24, 39, 0.78);
  backdrop-filter: blur(10px);
}

.lock-card {
  width: min(560px, 100%);
  padding: 38px;
  border: 1px solid rgba(84, 120, 96, 0.2);
  border-radius: 28px;
  background: linear-gradient(145deg, #fffaf0 0%, #f4fbf6 100%);
  box-shadow: 0 30px 80px rgba(17, 24, 39, 0.28);
  color: #22352b;
  text-align: center;
}

.lock-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 78px;
  height: 78px;
  margin-bottom: 18px;
  border-radius: 24px;
  color: #2f6f55;
  background: #dff3e7;
}

.lock-icon {
  width: 44px;
  height: 44px;
}

.eyebrow {
  margin-bottom: 10px;
  color: #5f7f69;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.lock-card h2 {
  margin-bottom: 14px;
  color: #1f3328;
  font-size: clamp(26px, 4vw, 36px);
  line-height: 1.2;
}

.lock-desc {
  margin-bottom: 24px;
  color: #526457;
  font-size: 16px;
  line-height: 1.8;
}

.lock-panel {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  margin-bottom: 22px;
}

.lock-panel div {
  padding: 18px;
  border: 1px solid rgba(84, 120, 96, 0.16);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.72);
  text-align: left;
}

.lock-panel span {
  display: block;
  margin-bottom: 8px;
  color: #708174;
  font-size: 13px;
}

.lock-panel strong {
  display: block;
  color: #284836;
  font-size: 17px;
}

.lock-tip {
  margin: 0;
  padding: 12px 16px;
  border-radius: 999px;
  background: rgba(47, 111, 85, 0.1);
  color: #3d634e;
  font-size: 14px;
}

@media (max-width: 640px) {
  .youth-lock {
    padding: 16px;
  }

  .lock-card {
    padding: 28px 20px;
    border-radius: 22px;
  }

  .lock-panel {
    grid-template-columns: 1fr;
  }
}
</style>
